import { render, staticRenderFns } from "./genders.vue?vue&type=template&id=e1261140&"
import script from "./genders.vue?vue&type=script&lang=js&"
export * from "./genders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports